

























































































































































































































































import {
  FormFieldOptionTodo,
  IDepartment,
  IDepartmentData,
  IFormFieldOptionData,
  IFormFieldOptionTodo,
  IFormFieldOptionTodoData,
  IFormFieldOptionTodoTemplateData,
  IFormSectionFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';

import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import EmployeeUserPicker from '@/components/employee/EmployeeUserPicker.vue';
import HRDepartmentPicker from '@/components/employee/hr/HRDepartmentPicker.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import FormBuilderTodoTemplatePicker from './FormBuilderTodoTemplatePicker.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { ALForm } from '@/common/component.types';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import {
  IFetchFormFieldOptionTodosParams,
  IFormFieldOptionTodosPayload
} from '@/services';
import { diffDeep } from '@/utils/helpers';
import { IUserData } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData.types';
import { cloneDeep } from 'lodash';
import Proxyable from '@/mixins/proxyable';
import { AxiosError } from 'axios';

const baseMixins = mixins(auth, Proxyable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    createForm: ALForm;
    editForm: ALForm;
  };
}

export enum Tabs {
  Existing,
  Create
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'FormBuilderTodoDrawer',

    components: {
      EmployeeUserPicker,
      HRDepartmentPicker,
      ErrorAlert,
      FormBuilderTodoTemplatePicker,
      ConfirmationDialog
    },

    props: {
      sectionField: Object as PropType<IFormSectionFieldData>,
      selectedOption: Object as PropType<IFormFieldOptionData>,
      templateId: Number
    },

    data() {
      return {
        Tabs,
        selectedOptionIndex: -1 as number,
        selectedTodoIndex: -1 as number,
        selectedTodoTemplate: null as null | IFormFieldOptionTodoTemplateData,

        originalTodoTemplate: null as null | IFormFieldOptionTodoTemplateData,

        formValid: false,
        editFormValid: false,
        formTodoTemplate: {} as IFormFieldOptionTodoTemplateData,

        loading: false,
        errorMessage: '',
        detailErrorMessage: '',

        deleteDialog: false,

        requiredRules: [(v: string) => !!v || 'This field is required'],

        tabs: null
      };
    },

    computed: {
      ...mapGetters({
        formFieldOptionTodos: 'formTemplate/getFormFieldOptionTodos',
        getFormTodoTemplateById: 'formTemplate/getFormTodoTemplateById',
        hrDepartments: 'hrDepartment/getHrDepartments',
        getOptionTodosBySectionFieldAndOptionId:
          'formTemplate/getOptionTodosBySectionFieldAndOptionId'
      }),

      formFieldOptionTodos(): IFormFieldOptionTodo[] {
        return this.getOptionTodosBySectionFieldAndOptionId(
          this.sectionField.id,
          this.selectedOption.id
        );
      }
    },

    methods: {
      ...mapActions({
        fetchHrDepartments: 'hrDepartment/fetchHrDepartments',
        createFormFieldOptionTodo: 'formTemplate/createFormFieldOptionTodo',
        createFormTodoTemplate: 'formTemplate/createFormTodoTemplate',
        fetchFormFieldOptionTodos: 'formTemplate/fetchFormFieldOptionTodos',
        updateFormTodoTemplate: 'formTemplate/updateFormTodoTemplate',
        updateFormFieldOptionTodo: 'formTemplate/updateFormFieldOptionTodo',
        deleteFormFieldOptionTodo: 'formTemplate/deleteFormFieldOptionTodo'
      }),

      validateForm(formRef: ALForm): boolean {
        let valid = false;
        if (formRef) {
          valid = formRef.validate();
        }
        return valid;
      },

      resetFormValidation(formRef: ALForm): void {
        if (formRef) {
          return formRef.resetValidation();
        }
      },

      openDialog(index: number) {
        this.selectedTodoIndex = index;
        this.deleteDialog = true;
      },

      closeFormTodoTemplate(index: number) {
        (this.formFieldOptionTodos[index]
          .todo_template as IFormFieldOptionTodoTemplateData) = this.originalTodoTemplate!;
        this.selectedOptionIndex = -1;
      },

      editFormTodoTemplate(index: number) {
        this.selectedOptionIndex = index;
        this.originalTodoTemplate = cloneDeep(
          this.formFieldOptionTodos[index]
            .todo_template as IFormFieldOptionTodoTemplateData
        );
      },

      closeDeleteDialog() {
        this.selectedOptionIndex = -1;
        this.selectedTodoIndex = -1;
        this.deleteDialog = false;
      },

      removeFieldTemplateOption() {
        this.clearAllErrors();
        this.loading = true;

        const params = {
          templateId: this.templateId
        } as IFetchFormFieldOptionTodosParams;

        this.deleteFormFieldOptionTodo({
          params,
          id: this.formFieldOptionTodos[this.selectedTodoIndex!].id
        })
          .then(() => {
            this.closeDeleteDialog();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      closeTodoDrawer() {
        this.internalValue = false;
      },

      async genDefaultDepartment(): Promise<number> {
        const departments = await this.tryGetOrFechDepartments();
        return departments[0].id!; //returns first department as default
      },

      getDepartmentInfo(todo: IFormFieldOptionTodoData) {
        return ((todo.todo_template as IFormFieldOptionTodoTemplateData)
          .todo_department as IDepartment).departmentInfo;
      },

      async tryGetOrFechDepartments(): Promise<IDepartment[]> {
        if (!this.hrDepartments || this.hrDepartments.length == 0) {
          this.clearAllErrors();
          await this.fetchHrDepartments().catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          });
        }
        return this.hrDepartments;
      },

      saveFormTodoTemplate(todo: IFormFieldOptionTodoData) {
        this.clearAllErrors();
        this.loading = true;

        const payload = diffDeep(
          todo.todo_template,
          this.getFormTodoTemplateById(
            (todo.todo_template as IFormFieldOptionTodoTemplateData).id
          ),
          true
        ) as IFormFieldOptionTodoTemplateData;

        if (payload.todo_department) {
          payload.todo_department = ((todo.todo_template as IFormFieldOptionTodoTemplateData)
            .todo_department as IDepartmentData).id!;
        }
        if (payload.assignee) {
          payload.assignee = ((todo.todo_template as IFormFieldOptionTodoTemplateData)
            .assignee as IUserData).id!;
        }

        this.selectedOptionIndex = -1;

        this.updateFormTodoTemplate(payload)
          .then(() => {
            this.$forceUpdate();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      },

      async addNewFormTodoTemplate() {
        if (this.validateForm(this.$refs.createForm)) {
          this.formTodoTemplate.order = this.formFieldOptionTodos.length + 1;

          const todo = await this.createFormTodoTemplate(this.formTodoTemplate);

          this.addFormFieldOptionTodo(todo);

          this.resetFormValidation(this.$refs.createForm);
          this.formTodoTemplate = {} as IFormFieldOptionTodoTemplateData;
        }
      },

      fieldOptionAlreadyExist(todo: IFormFieldOptionTodoTemplateData) {
        const template = this.formFieldOptionTodos.find(
          (optionTodo: IFormFieldOptionTodo) =>
            (optionTodo.todo_template as IFormFieldOptionTodoTemplateData).id ==
            todo.id
        );

        return template;
      },

      async addFormFieldOptionTodo(todo: IFormFieldOptionTodoTemplateData) {
        this.clearAllErrors();
        if (!todo || this.fieldOptionAlreadyExist(todo)) return;

        this.loading = true;

        try {
          const params = {
            templateId: this.templateId,
            sectionFieldId: this.sectionField.id
          } as IFetchFormFieldOptionTodosParams;

          const data = new FormFieldOptionTodo({
            section_field: this.sectionField.id!,
            todo_template: todo.id!,
            field_option: this.selectedOption.id!
          });

          const payload = { params, data } as IFormFieldOptionTodosPayload;
          await this.createFormFieldOptionTodo(payload);

          this.selectedTodoTemplate = null;
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.loading = false;
        }
      },

      clearAllErrors() {
        this.detailErrorMessage = '';
        this.errorMessage = '';
      },

      genTodos() {
        this.clearAllErrors();
        const params = {
          templateId: this.templateId,
          sectionFieldId: this.sectionField.id,
          fieldOptionId: this.selectedOption.id
        } as IFetchFormFieldOptionTodosParams;

        this.loading = true;

        this.fetchFormFieldOptionTodos({ params })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  });
